import { AsyncPipe, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { TransferCostCenterCostUnitDialogComponent } from './transfer-cost-center-cost-unit-dialog.component';

export * from './transfer-cost-center-cost-unit-dialog.component';
@NgModule({
    declarations: [ TransferCostCenterCostUnitDialogComponent ],
    imports: [
        AsyncPipe,
        CommonModule,
        MatDialogModule,
        GenericInputModule,
        MatButton,
        TranslateModule,
        ReactiveFormsModule,
        MatFormField,
        MatIcon,
        MatIconButton,
        MatLabel,
        MatOption,
        MatSelect,
        MatSuffix,
        MatDivider,
        MatProgressBar,

    ],
})
export class TransferCostCenterCostUnitDialogModule {
}
